"use strict";

require("core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Form = void 0;
require("core-js/modules/es.object.assign.js");
var _react = _interopRequireDefault(require("react"));
var _system = require("@chakra-ui/system");
var _bricks = require("../../system/bricks.types");
var _utils = require("../../system/utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function cov_zfb4dj91b() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Form/Form.tsx";
  var hash = "bea77105b4fcd0d12d256a1a9813d6d2a9d4ef99";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Form/Form.tsx",
    statementMap: {
      "0": {
        start: {
          line: 9,
          column: 20
        },
        end: {
          line: 19,
          column: 2
        }
      },
      "1": {
        start: {
          line: 10,
          column: 17
        },
        end: {
          line: 10,
          column: 46
        }
      },
      "2": {
        start: {
          line: 11,
          column: 2
        },
        end: {
          line: 18,
          column: 4
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 9,
            column: 50
          },
          end: {
            line: 9,
            column: 51
          }
        },
        loc: {
          start: {
            line: 9,
            column: 66
          },
          end: {
            line: 19,
            column: 1
          }
        },
        line: 9
      }
    },
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    f: {
      "0": 0
    },
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "bea77105b4fcd0d12d256a1a9813d6d2a9d4ef99"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_zfb4dj91b = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_zfb4dj91b();
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var Form = exports.Form = (cov_zfb4dj91b().s[0]++, (0, _system.forwardRef)(function (props, ref) {
  cov_zfb4dj91b().f[0]++;
  var styles = (cov_zfb4dj91b().s[1]++, (0, _utils.useStyleConfig)('Form', props));
  cov_zfb4dj91b().s[2]++;
  return /*#__PURE__*/_react["default"].createElement(_bricks.bricks.form, _extends({
    ref: ref
    // __css has a lower priority than sx
    ,
    __css: styles
  }, props));
}));